function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8.3000002mm",
    height: "3.3mm",
    viewBox: "0 0 8.3000002 3.3",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.1014293,-2.5309754)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 4.1809754,
    cy: -12.25143,
    rx: 1.25,
    ry: 3.7500002,
    transform: "rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainHorizontal);
export default __webpack_public_path__ + "static/media/chain-horizontal.8f7204b48755efd4277a29233ab427e5.svg";
export { ForwardRef as ReactComponent };